import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../services/store';
import {
  getAllPublicSignals,
  selectAllSignalsNotSharedOrFollowedByCurrentMember,
} from '../../../../services/store/modules/signal';

const usePublicSignals = () => {
  const publicSignals = useSelector(
    selectAllSignalsNotSharedOrFollowedByCurrentMember,
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAllPublicSignals());
  }, [dispatch]);

  return {
    publicSignals,
  };
};

export default usePublicSignals;
